import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import styles from './Auth.module.css';

export default function Login() {
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);
  const [searchParams] = useSearchParams();
  const resetSuccess = searchParams.get('reset') === 'success';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) setError(error.message);
    setLoading(false);
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.logo}>Run<span>Staff</span>Run</div>
        <h1 className={styles.heading}>Sign in to your account</h1>
        <p className={styles.sub}>Access your PA contact database</p>

        <form onSubmit={handleSubmit} className={styles.form}>
          {resetSuccess && <div className="success-msg">Password updated. Sign in with your new password.</div>}
          {error && <div className="error-msg">{error}</div>}
          <div className="form-group">
            <label>Email address</label>
            <input
              className="form-input"
              type="email" required
              placeholder="you@company.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input
              className="form-input"
              type="password" required
              placeholder="••••••••"
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
          </div>
          <button className="btn btn-primary btn-full" type="submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <p className={styles.switch}>
          <Link to="/forgot-password">Forgot your password?</Link>
        </p>
        <p className={styles.switch}>
          Don't have an account? <Link to="/signup">Start free trial</Link>
        </p>
      </div>
    </div>
  );
}
